import React from "react";

const ASP_VB_Functions = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP VB Functions</h1>
      <p>This is the ASP VB Functions page content.</p>
    </div>
  );
};

export default ASP_VB_Functions;
